import { render, staticRenderFns } from "./RoleApplyPanel.vue?vue&type=template&id=064cd8cc&scoped=true"
import script from "./RoleApplyPanel.vue?vue&type=script&lang=js"
export * from "./RoleApplyPanel.vue?vue&type=script&lang=js"
import style0 from "./RoleApplyPanel.vue?vue&type=style&index=0&id=064cd8cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064cd8cc",
  null
  
)

export default component.exports